/**
 * Recursively merges objects using Object.assign
 * @param {object} target - The target object to merge into
 * @param {object} source - The source object to merge from
 * @returns {object} The merged object
 */
export const deepAssign = <T extends object, U extends object>(
	target: T,
	source: U,
): T & U => {
	const output = Object.assign({}, target);

	for (const key in source) {
		if (source[key] && typeof source[key] === "object") {
			output[key] = deepAssign(output[key] || {}, source[key]);
		} else {
			output[key] = source[key];
		}
	}

	return output as T & U;
};
